import { useAppContext } from "context/app-context";
import { ReactHelmetWithProvider } from "./ReactHelmetProvider";
import { RAISE_API_V1_URL } from "constants/endpoints";
import { post } from "services/api";
import { getCookie } from "services/cookies";
import { COOKIES } from "constants/cookies";

export const ZendeskProvider = () => {
  const { sessionInfo } = useAppContext();
  
  function authZendesk() {
    try {
      if (window.zE) {
        if (sessionInfo.isLoggedIn) {
          window.zE("messenger", "loginUser", function (callback) {
            post(`${RAISE_API_V1_URL}/zendesk/authenticate`)
              .then((response) => callback(response.data.token))
              .catch((error) => {
                console.error("Error authenticating user with Zendesk:", error);
              });
          });
        }
        else {
          window.zE("messenger", "logoutUser");
        }
      }
    } catch (e) {
      console.error("Error authenticating user with Zendesk:", e.message)
    }
  }

  return (
    <>
      <ReactHelmetWithProvider
        helmetOptions={{
          async: true,
          script: [{ src: `https://static.zdassets.com/ekr/snippet.js?key=${getCookie(COOKIES.REACT_APP_ZENDESK_WIDGET_KEY)}`, id: 'ze-snippet', onload: authZendesk() }]
        }}
      ></ReactHelmetWithProvider>
    </>
  );
};
